import { Link } from "react-router-dom";
import { Coins, Loader2 } from "lucide-react";
import { useSupercalcCredits } from "@/hooks/useSupercalcCredits";
import { useAuth } from "@/contexts/AuthContext";
import { cn } from "@/lib/utils";

interface TokenDisplayProps {
  className?: string;
  compact?: boolean;
}

export function TokenDisplay({ className, compact = false }: TokenDisplayProps) {
  const { user } = useAuth();
  const { totalCredits, loading, needsTopUp } = useSupercalcCredits();

  if (!user) return null;

  if (loading) {
    return (
      <div className={cn(
        "flex items-center gap-1.5 px-2 py-1 rounded-lg bg-card border border-border",
        className
      )}>
        <Loader2 className="h-3.5 w-3.5 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <Link 
      to="/membership" 
      className={cn(
        "flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-card border transition-colors hover:bg-accent/10",
        needsTopUp 
          ? "border-amber-500/50 text-amber-600 dark:text-amber-400" 
          : "border-border text-foreground",
        className
      )}
      title="View tokens & membership"
    >
      <Coins className={cn(
        "h-4 w-4",
        needsTopUp ? "text-amber-500" : "text-supercalc-brand"
      )} />
      <span className={cn(
        "font-medium tabular-nums",
        compact ? "text-xs" : "text-sm"
      )}>
        {totalCredits.toLocaleString()}
      </span>
      {!compact && (
        <span className="text-xs text-muted-foreground hidden sm:inline">tokens</span>
      )}
    </Link>
  );
}
